import {authQueryOptions} from '@/modules/auth/api'
import {hasConfigurationAccess} from '@/modules/auth/permissions'
import {AppLayout} from '@/modules/layout/app-layout/components/app-layout'
import {rqContext} from '@/router'
import {getUserPermissions, type Permission} from '@cypro/engine/utils'
import {createFileRoute, redirect} from '@tanstack/react-router'

// First item of the Configuration drawer the user may open, in menu order.
const CONFIGURATION_LANDING = [
  {permission: 'users.manage', to: '/configuration/users'},
  {permission: 'protocols.view', to: '/configuration/protocols'},
  {permission: 'catalogue.view', to: '/configuration/drug-catalog/active-substances'},
  {permission: 'organisation.manage', to: '/configuration/sections'},
  {permission: 'interfaces.manage', to: '/configuration/hl7'},
  {permission: 'settings.manage', to: '/configuration/settings'},
  {permission: 'logs.view', to: '/configuration/system-logs'},
  {permission: 'basic_data.manage', to: '/configuration/basic-data/categories'},
] as const satisfies readonly {permission: Permission; to: string}[]

export const Route = createFileRoute('/configuration')({
  beforeLoad: ({location}) => {
    const auth = rqContext.queryClient.getQueryData(authQueryOptions.queryKey)
    const permissions = getUserPermissions(auth?.session?.groups)

    if (!hasConfigurationAccess(permissions)) {
      throw redirect({to: '/patient-dashboard/patients', search: {forbidden: true}})
    }

    if (location.pathname !== '/configuration') return

    const landing = CONFIGURATION_LANDING.find(item => permissions.has(item.permission))
    throw redirect({to: landing?.to ?? '/patient-dashboard/patients'})
  },
  component: AppLayout,
})
